var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1330 2594 c-19 -2 -77 -9 -128 -15 -415 -48 -789 -210 -998 -432 -89 -95 -135 -166 -171 -265 -90 -245 16 -506 252 -623 78 -39 92 -42 183 -47 112 -5 179 9 274 60 70 37 166 135 202 206 61 120 71 272 26 400 -21 61 -21 64 -4 78 83 63 245 125 383 145 170 24 384 -1 539 -63 84 -35 175 -97 168 -117 -3 -9 -15 -43 -26 -75 -101 -283 77 -596 375 -656 298 -61 595 184 595 490 0 72 -33 206 -66 273 -159 316 -563 545 -1099 623 -98 14 -436 26 -505 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1764 c-49 -8 -110 -20 -135 -27 l-45 -13 -7 -66 c-26 -266 -210 -479 -468 -544 -59 -15 -178 -16 -299 -2 -20 3 -29 -9 -67 -82 -86 -169 -137 -351 -151 -539 l-6 -91 1383 0 1383 0 -7 88 c-16 189 -64 369 -142 523 l-43 87 -63 -15 c-83 -20 -231 -12 -319 16 -80 25 -199 101 -254 162 -97 107 -153 235 -163 378 l-7 86 -67 17 c-156 39 -359 47 -523 22z m377 -321 c88 -41 160 -113 201 -201 30 -62 32 -75 32 -172 0 -97 -2 -110 -31 -170 -53 -113 -136 -186 -253 -225 -80 -26 -217 -18 -291 18 -150 72 -240 213 -240 375 0 130 54 243 154 324 85 68 148 88 266 85 83 -2 104 -7 162 -34z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.285db09a6ef62c55af0873bd6da61351.svg";
export { ForwardRef as ReactComponent };